import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin-bottom: 0.5em;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25em;
  }
  
  .w1 {
    padding-right: 0.15em !important;
    width: 5em;

    .top-header {
      display: flex;
      justify-content: center !important;
      width: 100% !important;
      height: 2rem !important;
      padding: 0.5em 0em 0.5em 0em !important;
    }
  }

  .icon-button {
    cursor: pointer;
    margin: 0 0.1rem;
  }
`;

export const CardAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-top: 0.7em;
  overflow: auto;

  .card-atv-header {

  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: -0.3em;

    .top-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      height: 2em;
    }

    .padding-left {
      padding: 0;
      padding-left: 0.7em !important;
    }

    .row-top {
      margin-top: 0em !important;
      display: flex;
      flex-direction: row;
    }

    .w1 {
      padding-right: 0.15em !important;
      width: 5em;
    }

    .w2 {
      padding-right: 0.15em !important;
      width: 20em;

      Input{
        border-top-left-radius: 0.5em !important;
        border-bottom-left-radius: 0.5em !important;
      }
    }

    .w3 {
      padding-right: 0.15em !important;
      width: 8em;
    }

    .w4 {
      padding-right: 0.15em !important;
      width: 7em;
    }

    .w5 {
      padding-right: 0.15em !important;
      width: 24.2em;
      margin-right: 0.8em;

      Input{
        border-top-right-radius: 0.5em !important;
        border-bottom-right-radius: 0.5em !important;
      }
    }

    .row {
      width: auto;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0em;
        border-radius: 0;
        height: 2.5em;
      }

      TextArea:focus {
        height: 9.5em !important;
      }

      .list-analista {
        display: flex;
        flex-direction: column;

        .item-analista {
          margin-top: 0.5em;

          .icon-button {
            border: none;
            cursor: pointer;
            background: ${Colors.Color1};
            color: ${Colors.Color7};
            font-size: 1.125em;
            margin-right: 0.3em;
          }

          .padding-right {
            padding-right: 1em !important;
          }

          .col {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: 0em;

            p {
              font-size: 0.75em;
              color: ${Colors.Color7};
              font-weight: 500;
              margin-left: 0.5em;
              width: 11em;
            }
          }
        }
      }
    }

    .geraProjeto {
    
      input, TextArea {
        width: 100%;
        margin-top: 0em !important;
      }
    }
  }

  .sub-atividade {
    background: ${Colors.Color22};
    border-radius: 0.6em;
    padding-bottom: 0.6em;
    margin-bottom: 1em;
    margin-left: 1em;

    .top-header {
      button {
        width: 1.8rem !important;
        padding: 0 !important;
        height: 1.8rem !important;
        font-size: 1.5rem !important;
        line-height: 1rem !important;
        color: #fff !important;
      }
    }

    .titulos-tab {
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25em;
      background: ${Colors.Color23};
      color: ${Colors.Color9};
      border-radius: 0.5em;

      span {
        color: ${Colors.Color9};
      }

      .w1 {
        width: 4.7em !important;
      }
      
      .titulo {
        font-size: 0.75em;
        font-weight: 700;
        margin-left: 0.5em;
      }

      .atividade {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 20em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .data-prev-inicio {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .data-prev-entrega {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .data-entrega {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .hora-total {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .hora-lib {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .trav-os {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .hora-dia {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 7em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .hora-inicial {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 7em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .hora-final {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 7em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }

      .desc {
        height: 2.5em;
        padding: 0.5em 0em 0.5em 0.5em;
        display: flex;
        align-items: center;
        width: 23.2em;
        margin-right: 0.8em;

        .titulo {
          font-size: 0.75em;
          font-weight: 700;
          margin-left: 0.5em;
        }
      }
    }
  }
`;

export const CardTituloAtividade = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  background: ${Colors.Color4};
  color: ${Colors.Color9};
  border-radius: 0.5rem;
  height: 2.5rem;

  .col-atv {
    padding: 0em 0.4rem 0rem 0.4rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      line-height: 1.2rem;
    }
  }

  .col-atv.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20em;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .icon-button {
    border: none;
    cursor: pointer;
    background: ${Colors.Color1};
    color: ${Colors.Color7};
    font-size: 1.125em;
  }
`;

export const CardOSAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.3rem;

  .row-top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    
    select, input, TextArea {
      width: 100%;
      margin: 0em !important;
      border-radius: 0;
      height: 2.5em;
    }

    TextArea:focus {
      height: 9.5em !important;
    }
  }

  .col-atv {
    padding: 0em 0.1rem 0rem 0.1rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      margin-left: 0.5rem;
      line-height: 1.2rem;
    }
  }

  .col-atv.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20em;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .sub-atividade {
    background: ${Colors.Color22};
    border-radius: 0.6rem;
    padding-bottom: 0.6rem;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
    margin-left: 1.8rem;
  }
`;

export const CardTituloItemAtividade = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  background: ${Colors.Color23};
  color: ${Colors.Color9};
  border-radius: 0.5rem;
  height: 2.5rem;

  .col-atv-item {
    padding: 0em 0.4rem 0rem 0.4rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      line-height: 1.2rem;
    }
  }

  .col-atv-item.center {
    justify-content: center;
  }
  
  .col-1 {
    width: 5rem;
  }

  .col-2 {
    width: 10rem;
  }

  .col-3 {
    width: 15rem;
  }

  .col-4 {
    width: 20em;
  }
  
  .col-5 {
    width: 25rem;
  }

  .col-6 {
    width: 30rem;
  }

  .icon-button {
    border: none;
    cursor: pointer;
    background: ${Colors.Color1};
    color: ${Colors.Color7};
    font-size: 1.125em;
  }
`;

export const CardOSItemAtividade = styled.div`
  background: ${Colors.Color22};
  border-radius: 0.6rem;
  padding-bottom: 0.3rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .row-top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    select, input, TextArea {
      width: 100%;
      margin: 0em !important;
      border-radius: 0;
      height: 2.5em;
    }

    TextArea:focus {
      height: 9.5em !important;
    }
  }

  .col-atv-item {
    padding: 0em 0.1rem 0rem 0.1rem;
    display: flex;
    align-items: center;

    span {
      color: ${Colors.Color9};
    }

    .titulo {
      font-size: 0.8rem;
      font-weight: 700;
      margin-left: 0.5rem;
      line-height: 1.2rem;
    }
  }

  .col-atv-item.center {
    justify-content: center;
  }
`;
